import { render, staticRenderFns } from "./connection.vue?vue&type=template&id=47e5a293&"
import script from "./connection.vue?vue&type=script&lang=js&"
export * from "./connection.vue?vue&type=script&lang=js&"
import style0 from "./connection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports